import type { ProductNotificationSelections } from "../types/productNotificationMappings";

export const notificationChannelKeys = ["shouldEmail", "shouldWebInbox", "shouldMobileInbox", "shouldPush"] as const;
export const noProductNotificationChannels: ProductNotificationSelections = {
  shouldEmail: false, shouldWebInbox: false, shouldMobileInbox: false, shouldPush: false,
};

export function selectionsFromMapping(value: ProductNotificationSelections | null): ProductNotificationSelections {
  return {
    shouldEmail: value?.shouldEmail ?? false,
    shouldWebInbox: value?.shouldWebInbox ?? false,
    shouldMobileInbox: value?.shouldMobileInbox ?? false,
    shouldPush: value?.shouldPush ?? false,
  };
}

export function hasNotificationChannels(value: ProductNotificationSelections): boolean {
  return notificationChannelKeys.some(key => value[key]);
}

export function sameNotificationSelections(left: ProductNotificationSelections, right: ProductNotificationSelections): boolean {
  return notificationChannelKeys.every(key => left[key] === right[key]);
}

